<template>
  <input-el
    class="phone-input" :class="{'phone-input_active': active}"
    @focus="inputIsFocused = true"
    @blur="inputIsFocused = false"
    @input="onInput"
    @keypress="validateKey"
    maxlength="30"
    :value="valueWithoutPlus"
    v-bind="$attrs"
    autocomplete="off"
  />
</template>

<script>
import { getPressedChar, isNumber } from 'src/utils/helpers';

export default {
  inheritAttrs: false,
  data: () => ({
    inputIsFocused: false,
  }),
  props: {
    value: String,
  },
  methods: {
    validateKey(e) {
      if (!isNumber(getPressedChar(e)) && this.checkKeysExclusion(e.key)) {
        e.preventDefault();
      }
    },
    onInput(e) {
      this.$emit('input', `${e.replace(/\D/g, '')}`);
    },
    checkKeysExclusion(key) {
      return key !== 'Backspace' && key !== 'Delete' && key !== 'ArrowUp' && key !== 'ArrowDown' && key !== 'ArrowLeft' && key !== 'ArrowRight';
    },
  },
  computed: {
    active() {
      return this.inputIsFocused || this.value;
    },
    valueWithoutPlus() {
      return typeof this.value === 'string' && this.value.startsWith('+') ? this.value.substr(1) : this.value;
    },
  },
};
</script>

<style lang="scss">
  .phone-input {
    position: relative;
    .input {
      padding-left: 30px !important;
    }
    &_active {
      &:before {
        content: '+';
        position: absolute;
        left: 21px;
        top: 41px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/uikit/PhoneInput.vue